import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProjectService } from '../services/project.service';
import { RoleService } from '../services/user-role.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class ProjectGuard implements CanActivate {
	constructor(
		private router: Router,
		private projectService: ProjectService,
		private roleService: RoleService,
		private userService: UserService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
		const user = this.userService.getCurrentUser();
		const isOwner = user?.roles?.includes('Owner');

		if (isOwner) {
			return this.projectService.getProjects().pipe(
				map(projects => {
					const hasNoProjects = !projects || projects.length === 0;
					const isOnCreationPage = state.url.includes('/admin/projects/add');

					if (hasNoProjects && !isOnCreationPage) {
						return this.router.createUrlTree(['/admin/projects/add']);
					}

					return true;
				}),
				catchError(() =>
					// En cas d'erreur, on redirige aussi vers la création
					of(this.router.createUrlTree(['/admin/projects/add']))
				)
			);
		}

		return true;
	}

	canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(next, state);
	}

	canDeactivate(
		component: unknown,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot
	) {
		return true;
	}
}
